const footerStripeSvg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 4200 550"><defs><linearGradient id="footerStripeGradient" x1="-1488.81" y1="550" x2="4200" y2="550" gradientTransform="matrix(1.04, -0.25, 0.25, 1.04, -177.83, 525.68)" gradientUnits="userSpaceOnUse"><stop offset="0.42" stop-color="#b5e4fc" /><stop offset="0.92" stop-color="#1ad3ff" /></linearGradient></defs><polygon fill="url(#footerStripeGradient)" points="360,550 4200,0 4200,550" /></svg>';

export default theme => ({
  root: {
    height: 550,
    display: 'flex',
    alignItems: 'flex-end',
    marginTop: -120,
    paddingBottom: theme.spacing.unit * 5,
    background: {
      image: `url('data:image/svg+xml;utf8,${encodeURIComponent(footerStripeSvg)}')`,
      size: 'cover'
    },
    [theme.breakpoints.up('sm')]: {
      backgroundPosition: 'center bottom',
      justifyContent: 'flex-end',
      textAlign: 'right'
    },
    [theme.breakpoints.down('sm')]: {
      backgroundPosition: '60% bottom'
    }
  }
});



// WEBPACK FOOTER //
// ./src/components/Footer/styles.js